// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExtendedItem-module__font-s-10___IC8Z7 {
  font-size: 10px !important;
}

.ExtendedItem-module__font-s-12____QXtN {
  font-size: 12px !important;
}

.ExtendedItem-module__font-s-13___NhKFF {
  font-size: 13px !important;
}

.ExtendedItem-module__font-s-14___lFwqk {
  font-size: 14px !important;
}

.ExtendedItem-module__font-s-15___nQqDQ {
  font-size: 15px !important;
}

.ExtendedItem-module__font-s-16___g14CH {
  font-size: 16px !important;
}

.ExtendedItem-module__font-s-18___GARgU {
  font-size: 18px !important;
}

.ExtendedItem-module__font-s-20___RsO1_ {
  font-size: 20px !important;
}

.ExtendedItem-module__font-s-22___gzC0M {
  font-size: 22px !important;
}

.ExtendedItem-module__font-s-28____zPJg {
  font-size: 28px !important;
}

.ExtendedItem-module__font-w-400___wBAQC {
  font-weight: 400 !important;
}

.ExtendedItem-module__font-w-500___DWHly {
  font-weight: 500 !important;
}

.ExtendedItem-module__font-w-600___SnTD4 {
  font-weight: 600 !important;
}

.ExtendedItem-module__font-w-700___THOme {
  font-weight: 700 !important;
}

.ExtendedItem-module__p-5___PL5DO {
  padding: 5px !important;
}

.ExtendedItem-module__p-12___DYFyk {
  padding: 12px !important;
}

.ExtendedItem-module__p-16___t0N54 {
  padding: 16px !important;
}

.ExtendedItem-module__p-30___ii5pH {
  padding: 30px !important;
}

.ExtendedItem-module__p-b-0___qeW0q {
  padding-bottom: 0 !important;
}

.ExtendedItem-module__p-b-5___RdCuc {
  padding-bottom: 5px !important;
}

.ExtendedItem-module__p-b-10___iWQtC {
  padding-bottom: 10px !important;
}

.ExtendedItem-module__p-b-12___rPiWE {
  padding-bottom: 12px !important;
}

.ExtendedItem-module__p-b-16___IOfok {
  padding-bottom: 16px !important;
}

.ExtendedItem-module__p-b-18___DHoJL {
  padding-bottom: 18px !important;
}

.ExtendedItem-module__p-b-20___Jd1fB {
  padding-bottom: 20px !important;
}

.ExtendedItem-module__p-b-25___r9eFs {
  padding-bottom: 25px !important;
}

.ExtendedItem-module__p-b-30___g8hj4 {
  padding-bottom: 30px !important;
}

.ExtendedItem-module__p-b-50___hYxnq {
  padding-bottom: 50px !important;
}

.ExtendedItem-module__p-t-0___Uf8lm {
  padding-top: 0 !important;
}

.ExtendedItem-module__p-t-12___In2I_ {
  padding-top: 12px !important;
}

.ExtendedItem-module__p-t-16___Y2ioO {
  padding-top: 16px !important;
}

.ExtendedItem-module__p-t-18___eJ7Vy {
  padding-top: 18px !important;
}

.ExtendedItem-module__p-t-20___Kty_K {
  padding-top: 20px !important;
}

.ExtendedItem-module__p-t-30___ohVn1 {
  padding-top: 30px !important;
}

.ExtendedItem-module__p-t-40___a0bQd {
  padding-top: 40px !important;
}

.ExtendedItem-module__p-t-50___Iw93j {
  padding-top: 50px !important;
}

.ExtendedItem-module__p-l-20___XgVuj {
  padding-left: 20px !important;
}

.ExtendedItem-module__p-l-30___O63Oh {
  padding-left: 30px !important;
}

.ExtendedItem-module__p-l-40___wAG6O {
  padding-left: 40px !important;
}

.ExtendedItem-module__p-r-16___nnlNZ {
  padding-right: 16px !important;
}

.ExtendedItem-module__p-r-20___rrTnc {
  padding-right: 20px !important;
}

.ExtendedItem-module__p-r-30___Xg2Pj {
  padding-right: 30px !important;
}

.ExtendedItem-module__p-r-50___WBldj {
  padding-right: 50px !important;
}

.ExtendedItem-module__p-r-60___GR2Ur {
  padding-right: 60px !important;
}

.ExtendedItem-module__m-b-1___pKkcJ {
  margin-bottom: 1px !important;
}

.ExtendedItem-module__m-b-2___klE3v {
  margin-bottom: 2px !important;
}

.ExtendedItem-module__m-b-6___teUPf {
  margin-bottom: 6px !important;
}

.ExtendedItem-module__m-b-8___UcHCb {
  margin-bottom: 8px !important;
}

.ExtendedItem-module__m-b-10___wO83l {
  margin-bottom: 10px !important;
}

.ExtendedItem-module__m-b-14____ZTox {
  margin-bottom: 14px !important;
}

.ExtendedItem-module__m-b-16___onEgc {
  margin-bottom: 16px !important;
}

.ExtendedItem-module__m-b-20___WYptY {
  margin-bottom: 20px !important;
}

.ExtendedItem-module__m-b-22___i60Ne {
  margin-bottom: 22px !important;
}

.ExtendedItem-module__m-b-24___Q11RU {
  margin-bottom: 24px !important;
}

.ExtendedItem-module__m-b-30___hd05x {
  margin-bottom: 30px !important;
}

.ExtendedItem-module__m-b-32___lAMCw {
  margin-bottom: 32px !important;
}

.ExtendedItem-module__m-b-40___yAYY7 {
  margin-bottom: 40px !important;
}

.ExtendedItem-module__m-t-2___tNmbV {
  margin-top: 2px !important;
}

.ExtendedItem-module__m-t-3___i4dnw {
  margin-top: 3px !important;
}

.ExtendedItem-module__m-t-4___MXNhD {
  margin-top: 4px !important;
}

.ExtendedItem-module__m-t-5___SeWpd {
  margin-top: 5px !important;
}

.ExtendedItem-module__m-t-8___Gu9VG {
  margin-top: 8px !important;
}

.ExtendedItem-module__m-t-10___lWj43 {
  margin-top: 10px !important;
}

.ExtendedItem-module__m-t-15___u7x10 {
  margin-top: 15px !important;
}

.ExtendedItem-module__m-t-16___S7VXL {
  margin-top: 16px !important;
}

.ExtendedItem-module__m-t-20____snvU {
  margin-top: 20px !important;
}

.ExtendedItem-module__m-t-22___UsySt {
  margin-top: 22px !important;
}

.ExtendedItem-module__m-t-30___E3R2C {
  margin-top: 30px !important;
}

.ExtendedItem-module__m-t-32___LoiFR {
  margin-top: 32px !important;
}

.ExtendedItem-module__m-l-auto___QAofH {
  margin-left: auto !important;
}

.ExtendedItem-module__m-l-4___a03O3 {
  margin-left: 4px !important;
}

.ExtendedItem-module__m-l-5___DAx6e {
  margin-left: 5px !important;
}

.ExtendedItem-module__m-l-6___njCn5 {
  margin-left: 6px !important;
}

.ExtendedItem-module__m-l-8___sJB8y {
  margin-left: 8px !important;
}

.ExtendedItem-module__m-l-10___qCUhB {
  margin-left: 10px !important;
}

.ExtendedItem-module__m-l-16___q0nmF {
  margin-left: 16px !important;
}

.ExtendedItem-module__m-l-20___Z4nrv {
  margin-left: 20px !important;
}

.ExtendedItem-module__m-l-24___cTtvL {
  margin-left: 24px !important;
}

.ExtendedItem-module__m-l-30___XLu9W {
  margin-left: 30px !important;
}

.ExtendedItem-module__m-l-35___nQ185 {
  margin-left: 35px !important;
}

.ExtendedItem-module__m-l-40___gXCIx {
  margin-left: 40px !important;
}

.ExtendedItem-module__m-r-8___AAKxJ {
  margin-right: 8px !important;
}

.ExtendedItem-module__m-r-10___pHTw0 {
  margin-right: 10px !important;
}

.ExtendedItem-module__m-r-16___N_o4F {
  margin-right: 16px !important;
}

.ExtendedItem-module__m-r-20___STgxe {
  margin-right: 20px !important;
}

.ExtendedItem-module__m-r-24___MEbWM {
  margin-right: 24px !important;
}

.ExtendedItem-module__m-r-30___bthLg {
  margin-right: 30px !important;
}

.ExtendedItem-module__m-r-40___kddjB {
  margin-right: 40px !important;
}

.ExtendedItem-module__border-r-3___Q02Of {
  border-radius: 3px !important;
}

.ExtendedItem-module__border-r-4___wJ35m {
  border-radius: 4px !important;
}

.ExtendedItem-module__border-r-6___RTIWs {
  border-radius: 6px !important;
}

.ExtendedItem-module__border-r-10___crVav {
  border-radius: 10px !important;
}

.ExtendedItem-module__border-r-12___OTpAP {
  border-radius: 12px !important;
}

.ExtendedItem-module__border-r-16___PAQxO {
  border-radius: 16px !important;
}

.ExtendedItem-module__border-r-50___Bfg7c {
  border-radius: 50% !important;
}

.ExtendedItem-module__primary-border___kX3tB {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ExtendedItem-module__primary-border-b___Gxsux {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ExtendedItem-module__primary-border-t___DaEsn {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ExtendedItem-module__primary-border-l___p_xsV {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ExtendedItem-module__primary-border-r___jyUFz {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ExtendedItem-module__secondary-border___a_QBN {
  border: 1px solid #637768;
}

.ExtendedItem-module__secondary-border-b___pCBwf {
  border-bottom: 1px solid #637768;
}

.ExtendedItem-module__secondary-border-t___nmo5u {
  border-top: 1px solid #637768;
}

.ExtendedItem-module__secondary-border-l___dXySB {
  border-left: 1px solid #637768;
}

.ExtendedItem-module__secondary-border-r___NhoBZ {
  border-right: 1px solid #637768;
}

.ExtendedItem-module__gap-0___rndOF {
  gap: 0 !important;
}

.ExtendedItem-module__gap-2___RCE2i {
  gap: 2px !important;
}

.ExtendedItem-module__gap-4___nBW5V {
  gap: 4px !important;
}

.ExtendedItem-module__gap-5___ohwmE {
  gap: 5px !important;
}

.ExtendedItem-module__gap-6____oodB {
  gap: 6px !important;
}

.ExtendedItem-module__gap-8___LMfXo {
  gap: 8px !important;
}

.ExtendedItem-module__gap-10___HWbdR {
  gap: 10px !important;
}

.ExtendedItem-module__gap-12___uR1bj {
  gap: 12px !important;
}

.ExtendedItem-module__gap-14___SZ2Tt {
  gap: 14px !important;
}

.ExtendedItem-module__gap-16___hrMLI {
  gap: 16px !important;
}

.ExtendedItem-module__gap-18___F_Fvi {
  gap: 18px !important;
}

.ExtendedItem-module__gap-20___hrBiG {
  gap: 20px !important;
}

.ExtendedItem-module__gap-24___DGhvd {
  gap: 24px !important;
}

.ExtendedItem-module__gap-26___iXQO7 {
  gap: 26px !important;
}

.ExtendedItem-module__gap-30___emv9i {
  gap: 30px !important;
}

.ExtendedItem-module__gap-32___Z5UEt {
  gap: 32px !important;
}

.ExtendedItem-module__gap-40___v4nb9 {
  gap: 40px !important;
}

.ExtendedItem-module__gap-50___YHZDE {
  gap: 50px !important;
}

.ExtendedItem-module__flex-1___NJ550 {
  flex: 1;
}

.ExtendedItem-module__flex-none___JZhTU {
  flex: none !important;
}

.ExtendedItem-module__flex-column___ziOek {
  display: flex;
  flex-direction: column !important;
}

.ExtendedItem-module__flex-row___O_0GN {
  display: flex;
  flex-direction: row !important;
}

.ExtendedItem-module__vertically-centered___KYyS7 {
  display: flex;
  align-items: center !important;
}

.ExtendedItem-module__horizontally-centered___AGQvp {
  display: flex;
  justify-content: center !important;
}

.ExtendedItem-module__horizontally-end___GUmLJ {
  display: flex;
  justify-content: end !important;
}

.ExtendedItem-module__vertically-start___KNvEt {
  display: flex;
  align-items: start !important;
}

.ExtendedItem-module__space-between___vOC9t {
  display: flex;
  justify-content: space-between !important;
}

.ExtendedItem-module__flex-wrap___cw6CM {
  flex-wrap: wrap !important;
}

.ExtendedItem-module__height-100___HGtel {
  height: 100%;
}

.ExtendedItem-module__width-50___BAQrq {
  width: 50% !important;
}

.ExtendedItem-module__width-100___RDcAm {
  width: 100%;
}

.ExtendedItem-module__cursor-pointer___PYPXm {
  cursor: pointer;
}

.ExtendedItem-module__cursor-not-allowed___HTjMd {
  cursor: not-allowed !important;
}

.ExtendedItem-module__absolute-centered___toRpE {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ExtendedItem-module__absolute___XRzCG {
  position: absolute;
}

.ExtendedItem-module__relative___AJMoC {
  position: relative;
}

.ExtendedItem-module__fixed___vTHY9 {
  position: fixed;
}

.ExtendedItem-module__visible___z2pkT {
  opacity: 1;
}

.ExtendedItem-module__invisible___fusfg {
  opacity: 0;
}

.ExtendedItem-module__col-90___Pwb4H {
  width: 90% !important;
}

.ExtendedItem-module__col-auto___nOL4o {
  width: auto !important;
}

.ExtendedItem-module__medical-tabs___UcXd7 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ExtendedItem-module__medical-table-new___kV6Uq {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ExtendedItem-module__medical-table-new___kV6Uq:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ExtendedItem-module__medical-table-new___kV6Uq::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ExtendedItem-module__medical-table-new___kV6Uq::-webkit-scrollbar-track {
  display: none;
}
.ExtendedItem-module__medical-table-new___kV6Uq.ExtendedItem-module__no-pagination___uOMvI {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ExtendedItem-module__medical-table-new___kV6Uq.ExtendedItem-module__no-pagination___uOMvI:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ExtendedItem-module__medical-table-new___kV6Uq.ExtendedItem-module__no-pagination___uOMvI::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ExtendedItem-module__medical-table-new___kV6Uq.ExtendedItem-module__no-pagination___uOMvI::-webkit-scrollbar-track {
  display: none;
}

.ExtendedItem-module__medical-table-empty___jNEaV {
  padding: 14px 40px !important;
}

.ExtendedItem-module__icon-btn___XaWtj {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ExtendedItem-module__search-icon___EuwVU {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ExtendedItem-module__disable-select___XR3Hg {
  user-select: none;
}

.ExtendedItem-module__break-word___QK_4G {
  word-break: break-word;
}

.ExtendedItem-module__popup-clear-btn___SguqM {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ExtendedItem-module__scroll-m-b-20___cD7Wp {
  scroll-margin-bottom: 20px;
}

.ExtendedItem-module__container___bhrDH {
  padding: 6px 0 6px 18px;
  cursor: pointer;
  display: flex;
}
.ExtendedItem-module__container___bhrDH .ExtendedItem-module__dot___Jx63B {
  width: 8px;
  height: 8px;
  border-radius: 8px;
  visibility: hidden;
  display: inline-block;
}
.ExtendedItem-module__container___bhrDH .ExtendedItem-module__dot___Jx63B.ExtendedItem-module__selected___nQf__ {
  visibility: visible;
}
.ExtendedItem-module__container___bhrDH .ExtendedItem-module__orange____kusl {
  background-color: #f1bf72;
  margin: 7px 8px 2px 0;
}
.ExtendedItem-module__container___bhrDH .ExtendedItem-module__red___XVYAq {
  background-color: #f06c67;
  margin: 7px 0 2px 8px;
  visibility: visible;
}
.ExtendedItem-module__container___bhrDH .ExtendedItem-module__name___Tx2__ {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 150%;
  color: #637768;
}
.ExtendedItem-module__container___bhrDH .ExtendedItem-module__name___Tx2__.ExtendedItem-module__selected___nQf__ {
  font-weight: 700 !important;
  color: #375844;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/PatientDetailsSidebar/items/ExtendedItem/ExtendedItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,uBAAA;EACA,eAAA;EACA,aAAA;AA8pBF;AA5pBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AA8pBJ;AA5pBI;EACE,mBAAA;AA8pBN;AA1pBE;EACE,yBAAA;EACA,qBAAA;AA4pBJ;AAzpBE;EACE,yBAAA;EACA,qBAAA;EACA,mBAAA;AA2pBJ;AAxpBE;EEJA,+BApBO;EAqBP,gBAFmD;EFOjD,iBAAA;EACA,cAAA;AA2pBJ;AAzpBI;EACE,2BAAA;EACA,cAAA;AA2pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  padding: 6px 0 6px 18px;\n  cursor: pointer;\n  display: flex;\n\n  .dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 8px;\n    visibility: hidden;\n    display: inline-block;\n\n    &.selected {\n      visibility: visible;\n    }\n  }\n\n  .orange {\n    background-color: get-color(orangeNew, base);\n    margin: 7px 8px 2px 0;\n  }\n\n  .red {\n    background-color: get-color(redNew, medium-dark);\n    margin: 7px 0 2px 8px;\n    visibility: visible;\n  }\n\n  .name {\n    @include get-font($roboto);\n    line-height: 150%;\n    color: get-color(greenNew, medium-dark);\n\n    &.selected {\n      font-weight: 700 !important;\n      color: get-color(greenNew, dark);\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ExtendedItem-module__font-s-10___IC8Z7`,
	"fontS12": `ExtendedItem-module__font-s-12____QXtN`,
	"fontS13": `ExtendedItem-module__font-s-13___NhKFF`,
	"fontS14": `ExtendedItem-module__font-s-14___lFwqk`,
	"fontS15": `ExtendedItem-module__font-s-15___nQqDQ`,
	"fontS16": `ExtendedItem-module__font-s-16___g14CH`,
	"fontS18": `ExtendedItem-module__font-s-18___GARgU`,
	"fontS20": `ExtendedItem-module__font-s-20___RsO1_`,
	"fontS22": `ExtendedItem-module__font-s-22___gzC0M`,
	"fontS28": `ExtendedItem-module__font-s-28____zPJg`,
	"fontW400": `ExtendedItem-module__font-w-400___wBAQC`,
	"fontW500": `ExtendedItem-module__font-w-500___DWHly`,
	"fontW600": `ExtendedItem-module__font-w-600___SnTD4`,
	"fontW700": `ExtendedItem-module__font-w-700___THOme`,
	"p5": `ExtendedItem-module__p-5___PL5DO`,
	"p12": `ExtendedItem-module__p-12___DYFyk`,
	"p16": `ExtendedItem-module__p-16___t0N54`,
	"p30": `ExtendedItem-module__p-30___ii5pH`,
	"pB0": `ExtendedItem-module__p-b-0___qeW0q`,
	"pB5": `ExtendedItem-module__p-b-5___RdCuc`,
	"pB10": `ExtendedItem-module__p-b-10___iWQtC`,
	"pB12": `ExtendedItem-module__p-b-12___rPiWE`,
	"pB16": `ExtendedItem-module__p-b-16___IOfok`,
	"pB18": `ExtendedItem-module__p-b-18___DHoJL`,
	"pB20": `ExtendedItem-module__p-b-20___Jd1fB`,
	"pB25": `ExtendedItem-module__p-b-25___r9eFs`,
	"pB30": `ExtendedItem-module__p-b-30___g8hj4`,
	"pB50": `ExtendedItem-module__p-b-50___hYxnq`,
	"pT0": `ExtendedItem-module__p-t-0___Uf8lm`,
	"pT12": `ExtendedItem-module__p-t-12___In2I_`,
	"pT16": `ExtendedItem-module__p-t-16___Y2ioO`,
	"pT18": `ExtendedItem-module__p-t-18___eJ7Vy`,
	"pT20": `ExtendedItem-module__p-t-20___Kty_K`,
	"pT30": `ExtendedItem-module__p-t-30___ohVn1`,
	"pT40": `ExtendedItem-module__p-t-40___a0bQd`,
	"pT50": `ExtendedItem-module__p-t-50___Iw93j`,
	"pL20": `ExtendedItem-module__p-l-20___XgVuj`,
	"pL30": `ExtendedItem-module__p-l-30___O63Oh`,
	"pL40": `ExtendedItem-module__p-l-40___wAG6O`,
	"pR16": `ExtendedItem-module__p-r-16___nnlNZ`,
	"pR20": `ExtendedItem-module__p-r-20___rrTnc`,
	"pR30": `ExtendedItem-module__p-r-30___Xg2Pj`,
	"pR50": `ExtendedItem-module__p-r-50___WBldj`,
	"pR60": `ExtendedItem-module__p-r-60___GR2Ur`,
	"mB1": `ExtendedItem-module__m-b-1___pKkcJ`,
	"mB2": `ExtendedItem-module__m-b-2___klE3v`,
	"mB6": `ExtendedItem-module__m-b-6___teUPf`,
	"mB8": `ExtendedItem-module__m-b-8___UcHCb`,
	"mB10": `ExtendedItem-module__m-b-10___wO83l`,
	"mB14": `ExtendedItem-module__m-b-14____ZTox`,
	"mB16": `ExtendedItem-module__m-b-16___onEgc`,
	"mB20": `ExtendedItem-module__m-b-20___WYptY`,
	"mB22": `ExtendedItem-module__m-b-22___i60Ne`,
	"mB24": `ExtendedItem-module__m-b-24___Q11RU`,
	"mB30": `ExtendedItem-module__m-b-30___hd05x`,
	"mB32": `ExtendedItem-module__m-b-32___lAMCw`,
	"mB40": `ExtendedItem-module__m-b-40___yAYY7`,
	"mT2": `ExtendedItem-module__m-t-2___tNmbV`,
	"mT3": `ExtendedItem-module__m-t-3___i4dnw`,
	"mT4": `ExtendedItem-module__m-t-4___MXNhD`,
	"mT5": `ExtendedItem-module__m-t-5___SeWpd`,
	"mT8": `ExtendedItem-module__m-t-8___Gu9VG`,
	"mT10": `ExtendedItem-module__m-t-10___lWj43`,
	"mT15": `ExtendedItem-module__m-t-15___u7x10`,
	"mT16": `ExtendedItem-module__m-t-16___S7VXL`,
	"mT20": `ExtendedItem-module__m-t-20____snvU`,
	"mT22": `ExtendedItem-module__m-t-22___UsySt`,
	"mT30": `ExtendedItem-module__m-t-30___E3R2C`,
	"mT32": `ExtendedItem-module__m-t-32___LoiFR`,
	"mLAuto": `ExtendedItem-module__m-l-auto___QAofH`,
	"mL4": `ExtendedItem-module__m-l-4___a03O3`,
	"mL5": `ExtendedItem-module__m-l-5___DAx6e`,
	"mL6": `ExtendedItem-module__m-l-6___njCn5`,
	"mL8": `ExtendedItem-module__m-l-8___sJB8y`,
	"mL10": `ExtendedItem-module__m-l-10___qCUhB`,
	"mL16": `ExtendedItem-module__m-l-16___q0nmF`,
	"mL20": `ExtendedItem-module__m-l-20___Z4nrv`,
	"mL24": `ExtendedItem-module__m-l-24___cTtvL`,
	"mL30": `ExtendedItem-module__m-l-30___XLu9W`,
	"mL35": `ExtendedItem-module__m-l-35___nQ185`,
	"mL40": `ExtendedItem-module__m-l-40___gXCIx`,
	"mR8": `ExtendedItem-module__m-r-8___AAKxJ`,
	"mR10": `ExtendedItem-module__m-r-10___pHTw0`,
	"mR16": `ExtendedItem-module__m-r-16___N_o4F`,
	"mR20": `ExtendedItem-module__m-r-20___STgxe`,
	"mR24": `ExtendedItem-module__m-r-24___MEbWM`,
	"mR30": `ExtendedItem-module__m-r-30___bthLg`,
	"mR40": `ExtendedItem-module__m-r-40___kddjB`,
	"borderR3": `ExtendedItem-module__border-r-3___Q02Of`,
	"borderR4": `ExtendedItem-module__border-r-4___wJ35m`,
	"borderR6": `ExtendedItem-module__border-r-6___RTIWs`,
	"borderR10": `ExtendedItem-module__border-r-10___crVav`,
	"borderR12": `ExtendedItem-module__border-r-12___OTpAP`,
	"borderR16": `ExtendedItem-module__border-r-16___PAQxO`,
	"borderR50": `ExtendedItem-module__border-r-50___Bfg7c`,
	"primaryBorder": `ExtendedItem-module__primary-border___kX3tB`,
	"primaryBorderB": `ExtendedItem-module__primary-border-b___Gxsux`,
	"primaryBorderT": `ExtendedItem-module__primary-border-t___DaEsn`,
	"primaryBorderL": `ExtendedItem-module__primary-border-l___p_xsV`,
	"primaryBorderR": `ExtendedItem-module__primary-border-r___jyUFz`,
	"secondaryBorder": `ExtendedItem-module__secondary-border___a_QBN`,
	"secondaryBorderB": `ExtendedItem-module__secondary-border-b___pCBwf`,
	"secondaryBorderT": `ExtendedItem-module__secondary-border-t___nmo5u`,
	"secondaryBorderL": `ExtendedItem-module__secondary-border-l___dXySB`,
	"secondaryBorderR": `ExtendedItem-module__secondary-border-r___NhoBZ`,
	"gap0": `ExtendedItem-module__gap-0___rndOF`,
	"gap2": `ExtendedItem-module__gap-2___RCE2i`,
	"gap4": `ExtendedItem-module__gap-4___nBW5V`,
	"gap5": `ExtendedItem-module__gap-5___ohwmE`,
	"gap6": `ExtendedItem-module__gap-6____oodB`,
	"gap8": `ExtendedItem-module__gap-8___LMfXo`,
	"gap10": `ExtendedItem-module__gap-10___HWbdR`,
	"gap12": `ExtendedItem-module__gap-12___uR1bj`,
	"gap14": `ExtendedItem-module__gap-14___SZ2Tt`,
	"gap16": `ExtendedItem-module__gap-16___hrMLI`,
	"gap18": `ExtendedItem-module__gap-18___F_Fvi`,
	"gap20": `ExtendedItem-module__gap-20___hrBiG`,
	"gap24": `ExtendedItem-module__gap-24___DGhvd`,
	"gap26": `ExtendedItem-module__gap-26___iXQO7`,
	"gap30": `ExtendedItem-module__gap-30___emv9i`,
	"gap32": `ExtendedItem-module__gap-32___Z5UEt`,
	"gap40": `ExtendedItem-module__gap-40___v4nb9`,
	"gap50": `ExtendedItem-module__gap-50___YHZDE`,
	"flex1": `ExtendedItem-module__flex-1___NJ550`,
	"flexNone": `ExtendedItem-module__flex-none___JZhTU`,
	"flexColumn": `ExtendedItem-module__flex-column___ziOek`,
	"flexRow": `ExtendedItem-module__flex-row___O_0GN`,
	"verticallyCentered": `ExtendedItem-module__vertically-centered___KYyS7`,
	"horizontallyCentered": `ExtendedItem-module__horizontally-centered___AGQvp`,
	"horizontallyEnd": `ExtendedItem-module__horizontally-end___GUmLJ`,
	"verticallyStart": `ExtendedItem-module__vertically-start___KNvEt`,
	"spaceBetween": `ExtendedItem-module__space-between___vOC9t`,
	"flexWrap": `ExtendedItem-module__flex-wrap___cw6CM`,
	"height100": `ExtendedItem-module__height-100___HGtel`,
	"width50": `ExtendedItem-module__width-50___BAQrq`,
	"width100": `ExtendedItem-module__width-100___RDcAm`,
	"cursorPointer": `ExtendedItem-module__cursor-pointer___PYPXm`,
	"cursorNotAllowed": `ExtendedItem-module__cursor-not-allowed___HTjMd`,
	"absoluteCentered": `ExtendedItem-module__absolute-centered___toRpE`,
	"absolute": `ExtendedItem-module__absolute___XRzCG`,
	"relative": `ExtendedItem-module__relative___AJMoC`,
	"fixed": `ExtendedItem-module__fixed___vTHY9`,
	"visible": `ExtendedItem-module__visible___z2pkT`,
	"invisible": `ExtendedItem-module__invisible___fusfg`,
	"col90": `ExtendedItem-module__col-90___Pwb4H`,
	"colAuto": `ExtendedItem-module__col-auto___nOL4o`,
	"medicalTabs": `ExtendedItem-module__medical-tabs___UcXd7`,
	"medicalTableNew": `ExtendedItem-module__medical-table-new___kV6Uq`,
	"noPagination": `ExtendedItem-module__no-pagination___uOMvI`,
	"medicalTableEmpty": `ExtendedItem-module__medical-table-empty___jNEaV`,
	"iconBtn": `ExtendedItem-module__icon-btn___XaWtj`,
	"searchIcon": `ExtendedItem-module__search-icon___EuwVU`,
	"disableSelect": `ExtendedItem-module__disable-select___XR3Hg`,
	"breakWord": `ExtendedItem-module__break-word___QK_4G`,
	"popupClearBtn": `ExtendedItem-module__popup-clear-btn___SguqM`,
	"scrollMB20": `ExtendedItem-module__scroll-m-b-20___cD7Wp`,
	"container": `ExtendedItem-module__container___bhrDH`,
	"dot": `ExtendedItem-module__dot___Jx63B`,
	"selected": `ExtendedItem-module__selected___nQf__`,
	"orange": `ExtendedItem-module__orange____kusl`,
	"red": `ExtendedItem-module__red___XVYAq`,
	"name": `ExtendedItem-module__name___Tx2__`
};
module.exports = ___CSS_LOADER_EXPORT___;
